import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  modalTitle: {
    fontSize: "16px",
    letterSpacing: "0.44px",
    lineHeight: "24px",
    paddingBottom: "4px",
    textTransform: "capitalize",
  },
  modalContent: {
    width: "200px",
    fontSize: theme.typography.caption.fontSize,
    textAlign: "center",
    display: "flex",
    justifyContent: "center",
    paddingBottom: "2px",
  },
}));
